import { useState } from 'react';

const FORM_ENDPOINT = 'https://readdy.ai/api/form/daeimprep053ijub1ch0';

export default function Subscribe() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = (fd.get('website_alt') as string) || '';
    if (honeypot.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功,感谢你的关注!');
      form.reset();
      return;
    }

    setSubmitting(true);
    setStatus('idle');
    setMessage('');
    try {
      const body = new URLSearchParams();
      Array.from(fd.entries()).forEach(([k, v]) => {
        if (v && v !== '') body.append(k, v as string);
      });
      const res = await fetch(FORM_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = responseText ? JSON.parse(responseText) : {};
      } catch {
        parsed = {};
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');
      if (res.ok && parsed?.code === 'OK' && !isSpam) {
        setStatus('success');
        setMessage('订阅成功,最新快讯将第一时间发送到你的邮箱!');
        form.reset();
      } else {
        setStatus('error');
        setMessage(serverMsg || '提交失败,请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常,请稍后再试。');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="subscribe" className="scroll-mt-24 bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="overflow-hidden rounded-3xl border border-background-200">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* left visual */}
            <div className="relative flex flex-col justify-between overflow-hidden bg-primary-700 p-7 text-background-50 md:p-10">
              <div className="pointer-events-none absolute -right-8 -top-10 select-none font-heading text-[120px] font-black leading-none text-background-50/10">
                瓜
              </div>
              <div>
                <p className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-accent-300">
                  <i className="ri-mail-send-line text-base"></i>
                  每日快讯订阅
                </p>
                <h2 className="font-heading text-2xl font-black leading-snug text-balance md:text-3xl">
                  每天几分钟,把当天的瓜田风向一次性看明白
                </h2>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-background-100/90">
                  留下你的邮箱,我们会把每天筛选后的全网热点精选与热搜榜单,打包成一份清爽的早报/晚报,第一时间送到你的收件箱。
                </p>
              </div>
              <ul className="mt-8 grid grid-cols-1 gap-3 text-sm text-background-50 sm:grid-cols-2">
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-accent-300"></i>
                  每日精选,拒绝信息轰炸
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-accent-300"></i>
                  随时退订,无任何打扰
                </li>
              </ul>
            </div>

            {/* right form */}
            <div className="flex items-center bg-background-100 p-7 md:p-10">
              <form id="newsletter-form" data-readdy-form onSubmit={handleSubmit} className="w-full max-w-md space-y-4">
                <div>
                  <label htmlFor="nickname" className="mb-1.5 block text-sm font-semibold text-foreground-900">
                    怎么称呼你
                  </label>
                  <input
                    id="nickname"
                    name="nickname"
                    type="text"
                    autoComplete="off"
                    placeholder="你的昵称"
                    className="w-full rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="mb-1.5 block text-sm font-semibold text-foreground-900">
                    邮箱地址 <span className="text-primary-600">*</span>
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    autoComplete="off"
                    placeholder="you@example.com"
                    className="w-full rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                  />
                </div>
                <div>
                  <label htmlFor="preference" className="mb-1.5 block text-sm font-semibold text-foreground-900">
                    最关心的话题
                  </label>
                  <select
                    id="preference"
                    name="preference"
                    defaultValue="娱乐·科技·社会综合"
                    className="w-full cursor-pointer rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                  >
                    <option>娱乐·科技·社会综合</option>
                    <option>娱乐明星动态</option>
                    <option>科技与数码</option>
                    <option>社会民生</option>
                    <option>网络文化</option>
                    <option>体育与财经</option>
                  </select>
                </div>

                {/* anti-spam honeypot */}
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="fa-auxiliary-field"
                />

                <button
                  type="submit"
                  disabled={submitting}
                  className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
                >
                  {submitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin"></i>
                      正在提交…
                    </>
                  ) : (
                    <>
                      订阅每日快讯
                      <i className="ri-arrow-right-line"></i>
                    </>
                  )}
                </button>

                {status === 'success' && (
                  <div className="flex items-start gap-2 rounded-lg border border-secondary-200 bg-secondary-50 px-3 py-2.5 text-sm text-secondary-800">
                    <i className="ri-checkbox-circle-fill mt-0.5"></i>
                    {message}
                  </div>
                )}
                {status === 'error' && (
                  <div className="flex items-start gap-2 rounded-lg border border-primary-200 bg-primary-50 px-3 py-2.5 text-sm text-primary-800">
                    <i className="ri-error-warning-fill mt-0.5"></i>
                    {message}
                  </div>
                )}

                <p className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-mail-line"></i>
                  投稿与建议:hello@51heigua.cn
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}